const TheModule = () => import("./TheModule.vue");
const TheProposals = () => import("./views/TheProposals.vue");
const TheProposal = () => import("./views/TheProposal.vue");

const moduleRoute = {
  path: "/proposals",
  component: TheModule,
  meta: {
    requiresAuthenticated: true
  },
  children: [
    {
      path: "/",
      component: TheProposals,
      meta: {
        requiresAuthenticated: true,
        // hide: true
      }
    },
    {
      path: ":id",
      props: true,
      component: TheProposal,
      meta: {
        requiresAuthenticated: true,
        // hide: true
      }
    },

  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
